module.exports = __webpack_public_path__ + "static/media/quote.0f48b368.svg";